import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
    topLeftItem: {
        fontSize: '12px',
        paddingRight: theme.spacing(5)
    }
}))
